module.exports = __webpack_public_path__ + "img/ccompany-honor-RoHS-20240531.c174aab6.jpg";